module.exports = __webpack_public_path__ + "img/015.ac819ab3.png";